import React from "react";
import QrBottomNav from "../qr/QrBottomNav";

const NearbyBottomNav = ({ qrId, isOwner = false, isAuthenticated = false }) => {
  if (!qrId) return null;

  return (
    <QrBottomNav
      qrId={qrId}
      activeTab="nearby"
      isOwner={isOwner}
      isAuthenticated={isAuthenticated}
      variant="nearby"
      className="nearby-bottom-nav"
    />
  );
};

export default NearbyBottomNav;
